import React, { useState} from 'react';
// import data
import { header } from '../data';
// import icons
import { HiMenuAlt4, HiOutlineX } from 'react-icons/hi';
// import components
import MobileNav from '../components/MobileNav';
import Nav from '../components/Nav';
import { Link } from 'react-router-dom';

const Header = () => {
  // mobile nav state
  const [mobileNav, setMobileNav] = useState(false);
  const { logo, btnText } = header;
  // header state
  // const [isActive, setIsActive] = useState(false);
  // // destructure header data

  // // scroll event
  // useEffect(() => {
  //   window.addEventListener('scroll', () => {
  //     window.scrollY > 1 ? setIsActive(true) : setIsActive(false);
  //   });
  // }, []);
  return (
    <header className={`py-6 lg:py-4 fixed w-full transition-all z-10  bg-white text-black`} >
      <div className='container mx-auto flex justify-between items-center'>
        {/* logo */}
        <Link to='/'
          data-aos='fade-down'
          data-aos-delay='1000'>
          <img src={logo} alt='tdp-logo' className={` ${MobileNav ? 'hidden' : 'flex'}w-[100px] h-[100px]`} />
        </Link>
        {/* nav - initially hidden - show on desktop mode */}
        <div
          className='hidden lg:flex'
          data-aos='fade-down'
          data-aos-delay='1200'
        >
          <Nav />
        </div>

        {/* cta button - initially hidden - show on desktop mode */}
        <button
          className={`btn btn-sm btn-outline hidden lg:flex items-center  text-black bg-sky-400`}
          data-aos='fade-down'
          data-aos-delay='1400'
        >
          <Link to='/login'>
            {btnText}
          </Link>

        </button>
        {/* mobile nav trigger btn - hidden on desktop */}
        <button className='flex lg:hidden' onClick={() => setMobileNav((prev) => !prev)}>
          {mobileNav ? (
            <HiOutlineX className='text-3xl text-sky-400' />
          ) : (
            <HiMenuAlt4 className='text-3xl text-sky-400' />
          )}
        </button>
        {/* mobile nav - hidden on desktop */}
        <div
          className={`${mobileNav ? 'left-0' : '-left-full'
            }  fixed top-0 bottom-0 w-[60vw] lg:hidden transition-all`}
        >
          <MobileNav />
        </div>
      </div>
    </header>
  );
};

export default Header;
